export default "__VITE_ASSET__XUplB7fF__"